const allowedFileNames = {
  'cedula contable': 'cedula-contable',
  'cedula financiera': 'cedula-financiera',
  'cedula operativa': 'cedula-operativa',
  'cedula produccion': 'cedula-produccion',
  'finanzas cee': 'finanzas-cee',
  'fmp49 licencias': 'fmp49-licencias',
  'fmp50 licencias': 'fmp50-licencias',
  'fmp53': 'fmp53',
  'fmp54': 'fmp54',
  'produccion cee': 'produccion-cee',
  'sipac cee': 'sipac-cee',
}

export default allowedFileNames